import { safeParseNullDefault } from 'shouldve-been-js';

class Company {

    private _companyId: number;
    private _companyNo: number;
    private _name: string;
    private _address: string | null;
    private _phone: string | null;
    private _fax: string | null;
    private _email: string | null;
    private _url: string | null;
    private _vat: string | null;

    public constructor(companyId: number, companyNo: number, name: string, address: string | null, phone: string | null, fax: string | null, email: string | null, url: string | null, vat: string | null) {

        this._companyId = companyId;
        this._companyNo = companyNo;
        this._name = name;
        this._address = address;
        this._phone = phone;
        this._fax = fax;
        this._email = email;
        this._url = url;
        this._vat = vat;
    }

    public get companyId(): number {
        return this._companyId;
    }

    public set companyId(value: number) {
        this._companyId = value;
    }

    public get companyNo(): number {
        return this._companyNo;
    }

    public set companyNo(value: number) {
        this._companyNo = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get address(): string | null {
        return this._address;
    }

    public set address(value: string | null) {
        this._address = value;
    }

    public get phone(): string | null {
        return this._phone;
    }

    public set phone(value: string | null) {
        this._phone = value;
    }

    public get fax(): string | null {
        return this._fax;
    }

    public set fax(value: string | null) {
        this._fax = value;
    }

    public get email(): string | null {
        return this._email;
    }

    public set email(value: string | null) {
        this._email = value;
    }

    public get url(): string | null {
        return this._url;
    }

    public set url(value: string | null) {
        this._url = value;
    }

    public get vat(): string | null {
        return this._vat;
    }

    public set vat(value: string | null) {
        this._vat = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): Company | null {

        const companyId: number | null = safeParseNullDefault<number>(json?.companyId, 0);
        const companyNo: number | null = safeParseNullDefault<number>(json?.companyNo, 0);
        const name: string | null = safeParseNullDefault<string>(json?.name, '');
        const address: string | null = safeParseNullDefault<string>(json?.address, '');
        const phone: string | null = safeParseNullDefault<string>(json?.phone, '');
        const fax: string | null = safeParseNullDefault<string>(json?.fax, '');
        const email: string | null = safeParseNullDefault<string>(json?.email, '');
        const url: string | null = safeParseNullDefault<string>(json?.url, '');
        const vat: string | null = safeParseNullDefault<string>(json?.vat, '');

        if (companyId === null || companyNo === null || name === null || name === '') {
            return null;
        }
        
        return new Company(companyId, companyNo, name, address, phone, fax, email, url, vat);
    }
}

export default Company;